import { render } from "./defaultNoMenu.vue?vue&type=template&id=752354df&scoped=true"
import script from "./defaultNoMenu.vue?vue&type=script&lang=js"
export * from "./defaultNoMenu.vue?vue&type=script&lang=js"

import "./defaultNoMenu.vue?vue&type=style&index=0&id=752354df&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752354df"]])

export default __exports__